import type { InjectionKey, Ref } from 'vue'

interface ILoading {
  toggle: () => void
  set: (value: boolean) => void
  get: Ref<boolean>
}

export const LoadingKey: InjectionKey<ILoading> = Symbol('LoadingKey')
export const HiddenInput: InjectionKey<Ref<string>> = Symbol('HiddenInput')
